(() => {
  const roots = document.querySelectorAll("[data-unisource-faq]");

  if (!roots.length) return;

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function numberValue(value, fallback = 9999) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function sortByCategoryAndOrder(a, b) {
    const categoryOrderA = numberValue(a.dataset.categoryOrder, 999);
    const categoryOrderB = numberValue(b.dataset.categoryOrder, 999);

    if (categoryOrderA !== categoryOrderB) {
      return categoryOrderA - categoryOrderB;
    }

    const sortOrderA = numberValue(a.dataset.sortOrder, 9999);
    const sortOrderB = numberValue(b.dataset.sortOrder, 9999);

    if (sortOrderA !== sortOrderB) {
      return sortOrderA - sortOrderB;
    }

    const questionA = a.dataset.question || "";
    const questionB = b.dataset.question || "";

    return questionA.localeCompare(questionB);
  }

  roots.forEach((root) => {
    if (root.dataset.faqInitialized === "true") return;
    root.dataset.faqInitialized = "true";

    const searchInput = root.querySelector("[data-faq-search]");
    const categoryButtons = Array.from(root.querySelectorAll("[data-faq-category]"));
    const faqList = root.querySelector("[data-faq-list]");
    const featuredGrid = root.querySelector("[data-faq-featured-grid]");
    const countElement = root.querySelector("[data-faq-count]");
    const categoryHeading = root.querySelector("[data-faq-category-heading]");
    const emptyState = root.querySelector("[data-faq-empty]");
    const featuredButtons = Array.from(root.querySelectorAll("[data-faq-featured-link]"));

    let faqItems = Array.from(root.querySelectorAll("[data-faq-item]"));
    let activeCategory = "ordering";

    function sortFaqItems() {
      if (!faqList || faqItems.length < 2) return;
      faqItems.sort(sortByCategoryAndOrder);
      faqItems.forEach((item) => faqList.appendChild(item));
    }

    function sortAndLimitFeaturedItems() {
      if (!featuredGrid || featuredButtons.length < 1) return;
      featuredButtons.sort(sortByCategoryAndOrder);
      featuredButtons.forEach((button, index) => {
        featuredGrid.appendChild(button);
        button.hidden = index >= 6;
      });
    }

    function sortCategoryButtons() {
      const categoryWrap = root.querySelector("[data-faq-categories]");
      if (!categoryWrap) return;

      const allButton = categoryButtons.find((button) => button.dataset.faqCategory === "all");
      const otherButtons = categoryButtons
        .filter((button) => button.dataset.faqCategory !== "all")
        .sort((a, b) => {
          const orderA = numberValue(a.dataset.categoryOrder, 999);
          const orderB = numberValue(b.dataset.categoryOrder, 999);
          if (orderA !== orderB) return orderA - orderB;
          return a.textContent.trim().localeCompare(b.textContent.trim());
        });

      otherButtons.forEach((button) => categoryWrap.appendChild(button));
      if (allButton) categoryWrap.appendChild(allButton);
    }

    function closeItem(item) {
      const toggle = item.querySelector("[data-faq-toggle]");
      const answer = item.querySelector("[data-faq-answer]");
      if (!toggle || !answer) return;

      item.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      answer.hidden = true;
    }

    function openItem(item, options = {}) {
      const { scroll = false } = options;
      const toggle = item.querySelector("[data-faq-toggle]");
      const answer = item.querySelector("[data-faq-answer]");
      if (!toggle || !answer) return;

      faqItems.forEach((otherItem) => {
        if (otherItem !== item) closeItem(otherItem);
      });

      item.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      answer.hidden = false;

      if (scroll) {
        window.requestAnimationFrame(() => {
          item.scrollIntoView({ behavior: "smooth", block: "center" });
          toggle.focus({ preventScroll: true });
        });
      }
    }

    function toggleItem(item) {
      if (item.classList.contains("is-open")) {
        closeItem(item);
      } else {
        openItem(item);
      }
    }

    function updateCategoryHeading() {
      if (!categoryHeading) return;

      const activeButton = categoryButtons.find(
        (button) => (button.dataset.faqCategory || "all") === activeCategory
      );

      const label = activeButton
        ? activeButton.textContent.trim()
        : activeCategory === "all"
          ? "All questions"
          : activeCategory
              .split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ");

      categoryHeading.textContent =
        label.toLowerCase() === "all questions"
          ? "All Frequently Asked Questions"
          : label + " FAQs";
    }

    function applyFilters() {
      const query = normalize(searchInput?.value);
      let visibleCount = 0;

      faqItems.forEach((item) => {
        const itemCategory = item.dataset.category || "";
        const searchableText = normalize(item.dataset.search);
        const categoryMatches = activeCategory === "all" || itemCategory === activeCategory;
        const searchMatches = query === "" || searchableText.includes(query);
        const visible = categoryMatches && searchMatches;

        item.hidden = !visible;

        if (visible) {
          visibleCount += 1;
        } else {
          closeItem(item);
        }
      });

      if (countElement) countElement.textContent = String(visibleCount);
      if (emptyState) emptyState.hidden = visibleCount !== 0;

      updateCategoryHeading();
    }

    sortFaqItems();
    sortAndLimitFeaturedItems();
    sortCategoryButtons();

    faqItems.forEach((item) => {
      const toggle = item.querySelector("[data-faq-toggle]");
      if (!toggle) return;
      toggle.addEventListener("click", () => toggleItem(item));
    });

    categoryButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeCategory = button.dataset.faqCategory || "all";

        categoryButtons.forEach((otherButton) => {
          const active = otherButton === button;
          otherButton.classList.toggle("is-active", active);
          otherButton.setAttribute("aria-pressed", active ? "true" : "false");
        });

        applyFilters();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", applyFilters);
      searchInput.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          searchInput.value = "";
          applyFilters();
        }
      });
    }

    featuredButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const targetId = button.dataset.target;
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target || !root.contains(target)) return;

        activeCategory = "all";

        categoryButtons.forEach((categoryButton) => {
          const active = categoryButton.dataset.faqCategory === "all";
          categoryButton.classList.toggle("is-active", active);
          categoryButton.setAttribute("aria-pressed", active ? "true" : "false");
        });

        if (searchInput) searchInput.value = "";

        applyFilters();
        target.hidden = false;
        openItem(target, { scroll: true });
      });
    });

    const hash = window.location.hash;
    if (hash && hash.startsWith("#faq-")) {
      const target = root.querySelector(hash);
      if (target) {
        window.requestAnimationFrame(() => openItem(target, { scroll: true }));
      }
    }

    applyFilters();
  });

  const modal = document.querySelector("[data-inksoft-modal]");
  if (!modal) return;

  const modalFrame = modal.querySelector("[data-inksoft-modal-frame]");
  const modalTitle = modal.querySelector("[data-inksoft-modal-title]");
  const modalLoading = modal.querySelector("[data-inksoft-modal-loading]");
  const modalOpenLinks = Array.from(document.querySelectorAll("[data-inksoft-modal-open]"));
  const modalCloseButtons = Array.from(modal.querySelectorAll("[data-inksoft-modal-close]"));
  const modalMenuLinks = Array.from(modal.querySelectorAll("[data-inksoft-modal-menu-link]"));
  const modalSiteLinks = Array.from(modal.querySelectorAll("[data-inksoft-modal-site-link]"));

  let lastFocusedElement = null;

  function isModalOpen() {
    return !modal.hidden;
  }

  function clearActiveSiteLinks() {
    modalSiteLinks.forEach((button) => button.classList.remove("is-active"));
  }

  function setActiveModalMenu(mode) {
    modalMenuLinks.forEach((button) => {
      const active = button.dataset.modalMode === mode;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-current", active ? "page" : "false");
    });

    clearActiveSiteLinks();
  }

  function setModalLoadingState(isLoading) {
    if (!modalLoading) return;
    modalLoading.classList.toggle("is-hidden", !isLoading);
  }

  function loadInkSoftModalUrl(url, options = {}) {
    const { title = "Customer account", mode = "account" } = options;
    if (!url || !modalFrame) return;

    modal.dataset.modalMode = mode;

    if (modalTitle) modalTitle.textContent = title;

    setModalLoadingState(true);
    setActiveModalMenu(mode);

    if (modalFrame.getAttribute("src") === url) {
      setModalLoadingState(false);
      return;
    }

    modalFrame.src = url;
  }

  function openInkSoftModal(url, options = {}) {
    if (!url || !modalFrame) return;

    lastFocusedElement = document.activeElement;

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("unisource-faq-modal-open");

    loadInkSoftModalUrl(url, options);

    window.requestAnimationFrame(() => {
      const activeButton = modal.querySelector(".unisource-faq-modal__menu-button.is-active");
      const closeButton = modal.querySelector("[data-inksoft-modal-close]:not(.unisource-faq-modal__backdrop)");
      const focusTarget = activeButton || closeButton;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });
  }

  function closeInkSoftModal() {
    if (!isModalOpen()) return;

    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("unisource-faq-modal-open");

    if (modalFrame) modalFrame.removeAttribute("src");
    setModalLoadingState(true);
    setActiveModalMenu("");
    delete modal.dataset.modalMode;

    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      window.requestAnimationFrame(() => lastFocusedElement.focus({ preventScroll: true }));
    }
  }

  function navigateToSiteUrl(url) {
    if (!url) return;

    closeInkSoftModal();

    window.requestAnimationFrame(() => {
      window.location.assign(url);
    });
  }

  modalOpenLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();

      const url = link.getAttribute("href");
      const title = link.dataset.modalTitle || "Customer account";
      const mode = link.dataset.modalMode || "account";

      openInkSoftModal(url, { title, mode });
    });
  });

  modalMenuLinks.forEach((button) => {
    button.addEventListener("click", () => {
      const url = button.dataset.modalUrl;
      const title = button.dataset.modalTitle || button.textContent.trim();
      const mode = button.dataset.modalMode || "account";

      loadInkSoftModalUrl(url, { title, mode });
    });
  });

  modalSiteLinks.forEach((button) => {
    button.addEventListener("click", () => {
      const url = button.dataset.siteUrl;
      navigateToSiteUrl(url);
    });
  });

  modalCloseButtons.forEach((button) => {
    button.addEventListener("click", closeInkSoftModal);
  });

  if (modalFrame) {
    modalFrame.addEventListener("load", () => {
      setModalLoadingState(false);
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isModalOpen()) {
      closeInkSoftModal();
    }
  });
})();